import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M18.474 9.0984L10.974 16.5984C10.74 16.8324 10.4328 16.95 10.1256 16.95C9.8184 16.95 9.5112 16.8324 9.2772 16.5984L5.5272 12.8484C5.058 12.3792 5.058 11.6208 5.5272 11.1516C5.9964 10.6824 6.7548 10.6824 7.224 11.1516L10.1256 14.0532L16.7772 7.4016C17.2464 6.9324 18.0048 6.9324 18.474 7.4016C18.9432 7.8708 18.942 8.6292 18.474 9.0984Z"
    fill="currentColor"
  />
);

/**
 * The inside of `@o2/icons/CheckMarkFill` 'without the background' for _completed_ Steps in a `<Stepper variant="symbols" />`.
 *
 * Not added to `@o2/icons` to prevent introducing redundant icons.
 */
const InvertedCheckMarkFillIcon = createSvgIcon(svg, 'InvertedCheckMarkFill');

export default InvertedCheckMarkFillIcon;
